import axios from 'axios';
import SearchBox from 'components/common/SearchBox';
import PublicSettingsTable, {
  tableColumns
} from 'components/tables/PrivateSettingsTable';
import { errorHandler } from 'helpers/response-utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const PrivateSettings = () => {
  const nav = useNavigate();
  const [settings, setSettings] = useState([]);
  const token = localStorage.getItem('token');

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/private-settings`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    errorHandler(response);
    setSettings(response.data['data']['settings']);
  };

  const table = useAdvanceTable({
    data: settings,
    columns: tableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      getList: getList
    }
  });
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };
  return (
    <div>
      <div className="mb-6">
        <AdvanceTableProvider {...table}>
          <h2 className="mb-4">{settings.length} Settings</h2>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto"></Col>
            <Col xs="auto">
              <div className="d-flex">
                <SearchBox
                  placeholder="Search by name"
                  className="me-2"
                  onChange={handleSearchInputChange}
                />
              </div>
            </Col>
          </Row>
          <PublicSettingsTable />
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default PrivateSettings;
